import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'

import CustomImage from './CustomImage'
import Illustration from '../assets/images/illustration.png'
import LogoSmall from '../assets/images/logo.png'
import CustomHeading from './CustomHeading'
import CustomLabel from './CustomLabel'
import SignupForm from './Forms/Authentication/SignupForm'
import BackArrow from '../assets/images/backArrow.png'
import previmage from '../assets/images/previmage.PNG'
import PoweredByNural from './PoweredByNural'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: ' #EFF3FE',
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      padding: '20px 0px 15px 60px',
    },
  },
  content2: {
    background: 'linear-gradient(150.62deg, #32499F 0%, #05CFD3 60.52%, rgba(0, 208, 213, 0.2) 98.18%)',
    padding: '20px 0px 0px 36px',
    height: '100vh',
  },
  logoLarge: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      width: '200px',
    },
  },
  logoSmall: {
    // display: 'flex',
    // margin: '0px auto',
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      // marginBottom: '30px',
    },
  },

  content1: {
    backgroundColor: 'white',
    borderRadius: '20px',
    maxWidth: '518px',
    maxHeight: '540px',
    // minWidth: '518px',
    [theme.breakpoints.up('md')]: {
      // padding: '50px 20px 0px 20px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '30px 80px 50px 80px',
      display: 'grid',
      margin: 'auto',
    },
  },
  signupContent: {
    maxWidth: '518px',
    backgroundColor: 'white',
    borderRadius: '20px',
    maxHeight: '740px',
    marginTop: '20px',
    [theme.breakpoints.up('md')]: {
      padding: '50px 20px 0px 20px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '70px 60px 0px 60px',
    },
  },
  label: {
    // color: 'white',
    fontFamily: 'Open sans',
    fontSize: '36px',
    fontWeight: '600',
    paddingTop: '80px',
    paddingLeft: '10px',
    lineHeight: '20px',
    // textAlign: 'center',
  },
  image: {
    width: '76%',
  },
  heading2: {
    // textAlign: 'center',
    color: theme.palette.primary.main,
    marginTop: '30px',
    fontSize: '22px',
    fontWeight: 500,
    lineHeight: '20px',
  },
  backArrowImage: {
    position: 'relative',
    left: '-56px',
    cursor: 'pointer',
    // backgroundColor:'white',
    // marginBottom: '30px',
  },
  backArrow: {
    backgroundColor: 'white',
  },
  step1: {
    width: '48%',
    height: '5px',
    backgroundColor: '#33499F',
    borderRadius: '3px',
  },
  step12: {
    width: '48%',
    height: '5px',
    backgroundColor: '#999999',
    borderRadius: '3px',
  },
  step22: {
    width: '48%',
    height: '5px',
    backgroundColor: '#33499F',
    borderRadius: '3px',
  },
  resetPass: {
    maxWidth: '518px',
    maxHeight: '520px',
    backgroundColor: 'white',
    borderRadius: '20px',
    marginTop: '60px',
    [theme.breakpoints.up('md')]: {
      padding: '50px 20px 0px 20px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '70px 60px 0px 60px',
    },
  },
}))
export default function AuthModuleLayout({ children, login, step, handlePrev, resetPassword, signup, heading }) {
  const classes = useStyles()
  const history = useHistory()
  return (
    <Grid container className={classes.root}>
      <Grid item md={5} className={login ? classes.content1 : resetPassword ? classes.resetPass : classes.signupContent}>
        {(!login && step === 1) || step === 2 || resetPassword ? (
          <>
            <CustomImage image={previmage} onClick={resetPassword && step === 0 ? () => history.push('/') : handlePrev} className={classes.backArrowImage} />

            <br />
          </>
        ) : null}

        {/* <CustomImage image={LogoSmall} className={classes.logoSmall} /> */}
        <CustomHeading heading={heading ? heading : login ? 'Log in to your account' : resetPassword ? 'Reset Password' : 'Create  an account'} className={classes.heading2} />

        {signup && <br />}
        {login && <br />}
        {signup && <br />}
        {signup &&
          ((signup && step) === 0 ? (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className={classes.step1}></div>
              <div className={classes.step12}></div>
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className={classes.step1}></div>
              <div className={classes.step22}></div>
            </div>
          ))}

        {/* <br /> */}
        {children}
      </Grid>
      <Grid item md={1} />
      <Grid item md={6}>
        <CustomHeading heading="NURAL SALES" className={classes.label} />
        {/* <Typography className={classes.label}> NURAL SALES DASHBOARD</Typography> */}
        <CustomImage image={Illustration} className={classes.image} />
        <div style={{ marginRight: '125px' }}>
          <PoweredByNural />
        </div>
      </Grid>
    </Grid>
  )
}
